export enum InstrumentFilterStatus {
  Loading = 'loading',
  Error = 'error',
  Default = 'default'
}
